import React, { memo } from 'react';
import { Tooltip } from 'antd';

import useUserRoleInDoc from '../../hooks/useUserRoleInDoc';
import roles from '../../constants/roles';

import styles from '../table.module.scss';
import { getDocTitle } from '../utils/getDocTitle';

const NumberCell = memo(
  ({
    record,
    handleEditNumberDateClick,
    getPopupContainer = () => document.body,
  }) => {
    const type = record.type && record.type.id;
    const userRole = useUserRoleInDoc(record);
    // const allowEdit = userRole === roles.RESPONSIBLE_OR_AUTHOR;

    const text = getDocTitle(record);

    return (
      type && (
        <div
          className={styles.tdItem}
          style={{ color: '#09a2f2' }}
        >
          {(type != 3 && (
            <Tooltip
              title="Изменить номер документа"
              mouseLeaveDelay={0}
              getPopupContainer={getPopupContainer}
            >
              <span
                className="dspx-ref"
                onClick={(e) => {
                  handleEditNumberDateClick(e, record);
                }}
              >
                {text}
              </span>
            </Tooltip>
          )) || <span>{text}</span>}{' '}
        </div>
      )
    );
  }
);

export default NumberCell;
